/**
 * Tweet Utilities
 * Helper functions to process Twitter URLs and convert them to embeddable content
 */

export const extractTweetId = (url) => {
  if (!url) return null;
  
  try {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;
    
    if (pathname.includes('/status/')) {
      const parts = pathname.split('/');
      const statusIndex = parts.indexOf('status');
      if (statusIndex !== -1 && parts.length > statusIndex + 1) {
        return parts[statusIndex + 1].split('?')[0];
      }
    }
    
    return null;
  } catch (error) {
    console.error('Error parsing tweet URL:', error);
    return null;
  }
};

export const createTweetEmbed = (tweetUrlOrId) => {
  if (!tweetUrlOrId) return '';
  
  let tweetId = tweetUrlOrId;
  if (tweetUrlOrId.includes('twitter.com') || tweetUrlOrId.includes('x.com')) {
    tweetId = extractTweetId(tweetUrlOrId);
  }
  
  if (!tweetId) return '';
  
  return `
    <blockquote class="twitter-tweet" data-theme="dark" data-dnt="true">
      <a href="https://twitter.com/x/status/${tweetId}"></a>
    </blockquote>
  `;
};
